import React from "react";
import DensoLogo from "../../components/DensoLogo/DensoLogo";
import AuthViewLayout from "../../layouts/AuthViewLayout";
import HeadingContainer from "../../containers/HeadingContainer";
import { useIntl } from "react-intl";
import ForgotPassword from "../../containers/ForgotPassword/ForgotPassword";

function ForgotPasswordFormView() {
  const intl = useIntl();
  const welcomeMessage = intl.formatMessage({ id: "login.forgotPassword" });
  const login = intl.formatMessage({ id: "login.resetInstruction" });

  return (
    <AuthViewLayout
      topSection={<DensoLogo />}
      middleSection={
        <HeadingContainer
          level={2}
          heading={welcomeMessage}
          description={login}
        />
      }
      bottomSection={<ForgotPassword />}
    />
  );
}

export default ForgotPasswordFormView;
